import { Tabs } from '@seiue/ui'
import { SchoolPlugin, SchoolPluginTag, Term } from 'packages/sdks-next/growp'
import styled from 'styled-components'

import { allTagName, noTagName } from '../utils/util'

import { AppCard } from './components/AppCard'

type GroupPlugins = Record<string, GroupPlugin>

interface GroupPlugin {
  tagName: string
  tag?: Term | null
  schoolPlugins: SchoolPlugin[]
}

/**
 * 门户管理-应用列表-内容
 *
 * @param param - 参数
 * @param param.schoolPlugins - 应用列表
 * @param param.schoolPluginTags - 应用分类列表
 * @param param.isForground - 是否是前台
 * @param param.extraCard - 额外卡片
 * @returns 组件
 */
export const Content: React.FC<{
  schoolPlugins: SchoolPlugin[]
  schoolPluginTags: SchoolPluginTag[]
  isForground?: boolean
  extraCard?: React.ReactNode
}> = ({ schoolPlugins, schoolPluginTags, isForground, extraCard }) => {
  const groupPlugins: GroupPlugins = {
    全部应用: {
      tagName: allTagName,
      tag: null,
      schoolPlugins: schoolPlugins,
    },
  }

  schoolPlugins.forEach((item) => {
    const key = !item.tag ? noTagName : item.tag.name
    if (!groupPlugins[key]) {
      groupPlugins[key] = { tagName: key, tag: item.tag, schoolPlugins: [] }
    }
    groupPlugins[key].schoolPlugins.push(item)
  })

  const tabItems = schoolPluginTags
    .filter((tag) => groupPlugins[tag.name || allTagName] !== undefined)
    .map((tag) => {
      const currGroup = groupPlugins[tag.name || allTagName]
      const isOtherTag = tag.name !== allTagName

      return {
        label: currGroup.tagName,
        key: currGroup.tagName,
        children: (
          <ContentBox>
            {currGroup.schoolPlugins
              .sort(
                (a, b) =>
                  ((isOtherTag ? a.groupWeight : a.weight) || 0) -
                  ((isOtherTag ? b.groupWeight : b.weight) || 0)
              )
              .map((item) => (
                <AppCard
                  key={item.id}
                  schoolPlugin={item}
                  isForground={isForground}
                />
              ))}
            {extraCard}
          </ContentBox>
        ),
      }
    })

  return (
    <Box>
      <StyledTabs items={tabItems} />
    </Box>
  )
}

const StyledTabs = styled(Tabs)`
  & .ant-tabs-tab {
    font-weight: 400 !important;
    color: #455766;
  }
  & .ant-tabs-tab-active > .ant-tabs-tab-btn {
    color: ${(props) => props.theme.brand._1};
  }
  .ant-tabs-content-holder {
    overflow: auto;
    padding-right: 24px;
    margin-right: -24px;
  }
  height: 100%;
`

const Box = styled.div`
  height: 100%;
  width: 100%;
`

const ContentBox = styled.div`
  gap: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(276px, 1fr));
`
